module.exports = __webpack_public_path__ + "static/special-offer-436f0fdc65dd7470c578817e7b2fc6ad.png";